import CreatableReactSelect from "react-select/creatable";
import ReactSelect from "react-select";

interface ReactSelectOptions {
  creatable: boolean;
}

export const useReactSelect = ({
  creatable,
}: ReactSelectOptions): CreatableReactSelect | ReactSelect => {
  if (creatable) {
    return CreatableReactSelect;
  }

  return ReactSelect;
};
